//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import EvaluateScoreDrawer from "./modules/EvaluateScoreDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import dateSelect from '@/components/date/dateSelect';
import weekSelect from '@/components/date/weekSelect';
import monthSelect from '@/components/date/monthSelect';
import moment from 'moment';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
export default {
  name: 'EvaluateScoreList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    EvaluateScoreDrawer: EvaluateScoreDrawer,
    dateSelect: dateSelect,
    weekSelect: weekSelect,
    monthSelect: monthSelect
  },
  data: function data() {
    return {
      pagePath: '/om/evaluate/score',
      pageTitle: '评价与得分',
      reportType: '2',
      limitSelectDate: {},
      isAddBtn: true,
      autoLoadInit: false,
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点',
        align: 'center',
        sorter: true
      },
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, // {
      //   dataIndex: 'siteId',
      //   colName: 'site_id',
      //   title: '站点id',
      //   align: 'center',
      //   sorter: true,
      // },
      {
        dataIndex: 'reportDate',
        colName: 'report_date',
        title: '统计日期',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'isOnline_dictText',
        colName: 'is_onlie',
        title: '是否有效运行',
        align: 'center'
      }, {
        dataIndex: 'sewageDisposal',
        colName: 'sewage_disposal',
        title: '污水处理量（m³/d）',
        align: 'center'
      }, {
        dataIndex: 'outNum',
        colName: 'out_num',
        title: '出水抽检总次数',
        align: 'center'
      }, {
        dataIndex: 'outValidNum',
        colName: 'out_valid_num',
        title: '出水抽检中达标次数',
        align: 'center'
      }, {
        dataIndex: 'electricUsed',
        colName: 'electric_used',
        title: '耗电量（kW*h）',
        align: 'center'
      }, {
        dataIndex: 'drugUsed',
        colName: 'drug_used',
        title: '药耗（kg）',
        align: 'center'
      }, {
        dataIndex: 'complaintNum',
        colName: 'complaint_num',
        title: '投诉次数',
        align: 'center'
      }, {
        dataIndex: 'dealNum',
        colName: 'deal_num',
        title: '处理次数',
        align: 'center'
      }, {
        dataIndex: 'status_dictText',
        colName: 'status',
        title: '是否锁定',
        align: 'center'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      this.queryParam.scope = ids[0];
      this.queryParam.scopeId = ids[1];
      this.loadData();

      if (ids[0] == 1) {
        this.siteId = ids[1];
        this.isAddBtn = true; // 根据站点id

        this.spliceColumn(this.siteColumn);
      } else {
        this.isAddBtn = false; // 根据区域id

        this.spliceColumn(this.siteColumn, 1);
      }

      this.limitSelectDate = {
        min: moment().startOf('day').subtract(1, 'months'),
        max: moment().endOf('day')
      };
      this.queryParam.stime = this.limitSelectDate.min.format('YYYY-MM-DD');
      this.queryParam.etime = this.limitSelectDate.max.format('YYYY-MM-DD'); //this.queryParam.reportType = this.reportType
      //this.loadData()
    },
    currentSiteName: function currentSiteName(value) {
      this.siteName = value;
    }
  },
  created: function created() {},
  computed: {},
  methods: {
    loadData: function loadData() {
      this.queryParam.reportType = this.reportType;
      this.initTableData();
    },
    // 周变化
    weekChange: function weekChange(value) {
      this.queryParam.quantum = value[0] + '-' + value[1];
    },
    // 月变化
    monthChange: function monthChange(value) {
      this.queryParam.quantum = value;
    },
    // 报表类型变化
    reportTypeChange: function reportTypeChange(e) {
      this.reportType = e.target.value;

      if (this.reportType == '3') {
        this.queryParam.stime = this.limitSelectDate.min.format('YYYY-MM-DD');
        this.queryParam.etime = this.limitSelectDate.max.format('YYYY-MM-DD');
      }
    },
    // 时间区间变化
    onallChange: function onallChange(date, dateString) {
      this.queryParam.stime = dateString[0];
      this.queryParam.etime = dateString[1];
    },
    modalFormOk: function modalFormOk() {
      this.queryParam = this.queryParam;
      this.loadData();
    },
    searchReset: function searchReset() {
      this.queryParam = this.queryParam;
      this.loadData(1);
    }
  }
};